export default {
    name     : "videos",
    _selector: "[data-video]",
    _buttons : [],
    init() {
        this._buttons = document.querySelectorAll(this._selector);
        this._videos = document.querySelectorAll('.video-with-button');

        if (! this._buttons) {
            return;
        }

        this._buttons.forEach((btn) => btn.addEventListener('click', (el) => {
            const button = (el.target.classList.contains('video-button')) ?
                                el.target :
                                el.target.closest('.video-button');

            if (typeof button.dataset.video !== 'undefined') {
                const videoId = button.dataset.video;
                const video = document.getElementById(videoId);
                video.play();
                button.classList.add('d-none');
            }
        }));

        this._videos.forEach((video) => video.addEventListener('click', (el) => {
            const video = (el.target.classList.contains('video-with-button')) ?
                                el.target :
                                null;

            if (typeof video.id !== 'undefined') {
                const button = document.querySelector('button[data-video='+video.id+']')

                if (button) {
                    button.classList.toggle('d-none');
                }
            }
        }));
    }
};